export default (itemMetadata: $TSFixMe, itemGrade: $TSFixMe) => {
  return itemMetadata.isPeerReview() && itemGrade && itemGrade.get('overallOutcome').grade !== undefined;
};
